import Glide from '@glidejs/glide';


const initReferencesSliders = () => {

    const setupBlock = (block) => {

        const slider = block.querySelector(".glide");
        if (!slider) return;

        let options = {
            type: 'carousel',
            autoplay: false,
            touchRatio: 0.2,
            touchAngle: 30,
            swipeTreshold: 40,
            dragTreshold: 60,
            animationDuration: 1500,
            perView: 1,
            peek: 600,
            gap: 35,
            breakpoints: {
                1919: {
                    peek: 400,
                },
                1679: {
                    peek: 347,
                },
                1439: {
                    peek: 200,
                },
                900: {
                    peek: 100,
                },
                640: {
                    peek: 65,
                },
                500: {
                    peek: 40,
                    gap: 16,
                },
            }
        }
    
        const glide = new Glide(slider, options);

        /* setup control arrows and buttons */

        const arrowLeft  = block.querySelector(".js-left");
        const arrowRight = block.querySelector(".js-right");

        if (arrowLeft) {
            arrowLeft.addEventListener("click", () => {
                glide.go(`<`);
            })
        }

        if (arrowRight) {
            arrowRight.addEventListener("click", () => {
                glide.go(`>`);
            })
        }


        /* change slider cursor */

        slider.addEventListener('mousedown', () => { slider.style.cursor = 'grabbing' })
        slider.addEventListener('mouseup', () => { slider.style.cursor = 'grab' })
        slider.addEventListener('mouseenter', () => { slider.style.cursor = 'grab' })

        /* mount */

        glide.mount();
    }

    let blocks = document.querySelectorAll(".js-references-slider");

    if (!blocks) return;
    
    blocks.forEach(block => {
        setupBlock(block);
    });
    
}

export { initReferencesSliders }